import { render } from "./SputumForCytology.vue?vue&type=template&id=90d61d02&scoped=true"
import script from "./SputumForCytology.vue?vue&type=script&lang=js"
export * from "./SputumForCytology.vue?vue&type=script&lang=js"

import "./SputumForCytology.vue?vue&type=style&index=0&id=90d61d02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d61d02"]])

export default __exports__